module.exports = __webpack_public_path__ + "img/Victorian_State_Government_logo.c92740cc.png";